import { useEffect, useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { CadastroImobiliariaCorretorForm } from '@/features/proposta/brasil/components/cadastro-imobiliaria-corretor-form'
import { CadastroImobiliariaCorretorEntity } from '@/features/proposta/brasil/domain/cadastro-imobiliaria-corretor.entity'
import type { TDetalhesPropostaSchema } from '@/features/proposta/brasil/domain/schemas/detalhes-proposta-schema'
import { useCorretagens } from '@/features/proposta/brasil/hooks/use-corretagens'
import { ImobiliariaCorretorStepBase } from '@/features/proposta/shared/components/imobiliaria-corretor-step-base'

type TImobiliariaCorretorProps = {
  simulacoesIds: string[]
  exibeFormaPagamentoComissao?: boolean
  percentualCorretagem: number | null
  valorCorretagem: number | null
  handleRadioValueChange: (
    field: { onChange: (value: string) => void },
    entity: CadastroImobiliariaCorretorEntity,
  ) => (value: string) => void
}

const INCLUIR_PARTICIPACOES_PATH = 'detalhesDaProposta.imobiliariasCorretores.incluirParticipacoes'

const ImobiliariaCorretorStep = ({
  simulacoesIds,
  exibeFormaPagamentoComissao,
  percentualCorretagem,
  valorCorretagem,
  handleRadioValueChange,
}: TImobiliariaCorretorProps) => {
  const { data } = useCorretagens(simulacoesIds)
  const { control, watch, setValue, formState } = useFormContext<TDetalhesPropostaSchema>()

  const cadastroImobiliariaCorretorEntity = useMemo(
    () => new CadastroImobiliariaCorretorEntity(data ?? [], percentualCorretagem, valorCorretagem),
    [data, percentualCorretagem, valorCorretagem],
  )

  const participacoesPath = 'detalhesDaProposta.imobiliariasCorretores.participacoes'

  const isParticipacoesVazias = watch(participacoesPath)?.length === 0
  const incluirParticipacoes = watch(INCLUIR_PARTICIPACOES_PATH)
  const isStepCompleted = !formState.errors.detalhesDaProposta?.imobiliariasCorretores && incluirParticipacoes !== ''

  useEffect(() => {
    if (incluirParticipacoes !== 'Não' && isParticipacoesVazias) {
      setValue(INCLUIR_PARTICIPACOES_PATH, 'Não')
    }
  }, [isParticipacoesVazias, incluirParticipacoes, setValue])

  return (
    <ImobiliariaCorretorStepBase
      control={control}
      name={INCLUIR_PARTICIPACOES_PATH}
      completed={isStepCompleted}
      onSelecionar={(field) => handleRadioValueChange(field, cadastroImobiliariaCorretorEntity)}
    >
      <CadastroImobiliariaCorretorForm
        exibeFormaPagamentoComissao={exibeFormaPagamentoComissao}
        cadastroImobiliariaCorretoresEntity={cadastroImobiliariaCorretorEntity}
      />
    </ImobiliariaCorretorStepBase>
  )
}

export { ImobiliariaCorretorStep }
